package pogolitics.model

data class HomePageModel(val pokemonIndex: List<PokemonEntry>)